import { ShieldCheck } from 'lucide-react';
import type { ReactNode } from 'react';

interface AuthLayoutProps {
  title: string;
  subtitle: string;
  children: ReactNode;
  /** Optional: the two-factor step carries its own back-out action instead. */
  footer?: ReactNode;
}

export function AuthLayout({ title, subtitle, children, footer }: AuthLayoutProps) {
  return (
    <div className="flex min-h-screen flex-col bg-canvas">
      <div className="flex flex-1 items-center justify-center px-4 py-12">
        <div className="w-full max-w-sm">
          <div className="mb-8 flex items-center gap-2">
            <ShieldCheck className="size-6 text-accent" aria-hidden />
            <span className="text-lg font-semibold tracking-tight text-ink">AutoAware</span>
          </div>

          <h1 className="text-xl font-semibold tracking-tight text-ink">{title}</h1>
          <p className="mt-1 text-[13px] text-ink-secondary">{subtitle}</p>

          <div className="mt-6">{children}</div>

          {footer && <div className="mt-6 text-[13px] text-ink-secondary">{footer}</div>}
        </div>
      </div>

      <footer className="border-t border-line px-4 py-4 text-center text-[12px] text-ink-muted">
        Crash detection and emergency response · SafeSphere Tech
      </footer>
    </div>
  );
}
